export * from './instagram-dots/instagram-dots.component';
export { CarouselInstagramDotsComponent as CarouselInstagramDotsModule } from './instagram-dots/instagram-dots.component';
